import React from "react";
import { Search } from "lucide-react";

// Status pills shared by the client room and the vendor deliverables tab.
// Colours match the status badges on the deliverable cards.
export const DELIVERABLE_STATUS_FILTERS = [
  { value: "All", label: "All", bg: "#EEF0FF", text: "#4A3AFF" },
  { value: "pending", label: "Pending", bg: "#fff7e6", text: "#b45309" },
  { value: "downloaded", label: "Downloaded", bg: "#e0f2fe", text: "#0369a1" },
  { value: "approved", label: "Approved", bg: "#e6f4ea", text: "#137333" },
  { value: "rejected", label: "Rejected", bg: "#fce8e6", text: "#c5221f" },
];

// Legacy review states are shown (and counted) as pending.
const PENDING_ALIASES = ["in review", "unapproved"];

export const normalizeDeliverableStatus = (status) => {
  const s = (status || "pending").toLowerCase();
  return PENDING_ALIASES.includes(s) ? "pending" : s;
};

export const filterDeliverables = (deliverables, selectedStatus, searchQuery) => {
  const query = searchQuery.trim().toLowerCase();
  return deliverables.filter(
    (d) =>
      (selectedStatus === "All" ||
        normalizeDeliverableStatus(d.status) === selectedStatus) &&
      (d.name || d.filename || "").toLowerCase().includes(query)
  );
};

export default function DeliverableFilterBar({
  deliverables,
  searchQuery,
  setSearchQuery,
  selectedStatus,
  setSelectedStatus,
  theme,
}) {
  const counts = deliverables.reduce((acc, d) => {
    const s = normalizeDeliverableStatus(d.status);
    acc[s] = (acc[s] || 0) + 1;
    return acc;
  }, {});

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        style={{
          position: "relative",
          flex: "0 1 280px",
          minWidth: "200px",
        }}
      >
        <Search
          size={15}
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: theme.textSub,
            pointerEvents: "none",
          }}
        />
        <input
          type="text"
          placeholder="Search deliverables..."
          aria-label="Search deliverables"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: "100%",
            padding: "7px 12px 7px 32px",
            border: `1px solid ${theme.border}`,
            borderRadius: "20px",
            background: theme.cardBg,
            color: theme.textMain,
            fontSize: "13px",
            outline: "none",
          }}
        />
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
        {DELIVERABLE_STATUS_FILTERS.map((f) => {
          const isActive = selectedStatus === f.value;
          const count =
            f.value === "All" ? deliverables.length : counts[f.value] || 0;
          return (
            <button
              key={f.value}
              type="button"
              aria-pressed={isActive}
              onClick={() => setSelectedStatus(f.value)}
              style={{
                flexShrink: 0,
                fontSize: "11px",
                fontWeight: 600,
                padding: "3px 10px",
                borderRadius: "20px",
                border: isActive
                  ? `2px solid ${f.text}`
                  : `1.5px solid ${theme.border}`,
                background: isActive ? f.bg : theme.cardBg,
                color: isActive ? f.text : theme.textSub,
                cursor: "pointer",
                transition: "all 0.15s",
              }}
            >
              {f.label} ({count})
            </button>
          );
        })}
      </div>
    </div>
  );
}
